import React from 'react';

const DomainStats = ({ stats, loading }) => {
  if (loading) {
    return (
      <div className="domain-stats loading">
        <div className="stats-grid">
          {[...Array(4)].map((_, index) => (
            <div key={index} className="stat-card loading-card">
              <div className="stat-icon loading-shimmer"></div>
              <div className="stat-content">
                <div className="stat-number loading-shimmer"></div>
                <div className="stat-label loading-shimmer"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (!stats) {
    return null;
  }

  const statCards = [
    {
      title: 'Total Domains',
      value: stats.total_domains,
      icon: 'globe',
      color: 'blue',
      growth: stats.growth?.new_domains,
      growthLabel: 'new this month'
    },
    {
      title: 'Active Domains',
      value: stats.active_domains,
      icon: 'check-circle',
      color: 'green',
      percentage: stats.total_domains > 0 ? ((stats.active_domains / stats.total_domains) * 100).toFixed(1) : 0,
      percentageLabel: 'of total'
    },
    {
      title: 'SSL Enabled',
      value: stats.ssl_enabled_count,
      icon: 'lock',
      color: 'purple',
      percentage: stats.total_domains > 0 ? ((stats.ssl_enabled_count / stats.total_domains) * 100).toFixed(1) : 0,
      percentageLabel: 'coverage'
    },
    {
      title: 'Expiring Soon',
      value: stats.ssl_expiring_count,
      icon: 'exclamation-triangle',
      color: 'orange',
      growth: stats.ssl_expiring_count > 0 ? stats.ssl_expiring_count : 0,
      growthLabel: 'need attention'
    }
  ];

  return (
    <div className="domain-stats">
      <div className="stats-grid">
        {statCards.map((stat, index) => (
          <div key={index} className={`stat-card ${stat.color}`}>
            <div className="stat-icon">
              <i className={`fas fa-${stat.icon}`}></i>
            </div>
            
            <div className="stat-content">
              <div className="stat-number">{stat.value}</div>
              <div className="stat-label">{stat.title}</div>
              
              {stat.growth && (
                <div className="stat-growth">
                  <i className="fas fa-arrow-up"></i>
                  +{stat.growth} {stat.growthLabel}
                </div>
              )}
              
              {stat.percentage && (
                <div className="stat-percentage">
                  {stat.percentage}% {stat.percentageLabel}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Additional Stats Row */}
      <div className="additional-stats">
        <div className="stats-row">
          <div className="stat-item">
            <span className="stat-value">{stats.subdomain_count}</span>
            <span className="stat-desc">Subdomains</span>
          </div>
          
          <div className="stat-item">
            <span className="stat-value">{stats.custom_domain_count}</span>
            <span className="stat-desc">Custom Domains</span>
          </div>
          
          <div className="stat-item">
            <span className="stat-value">{stats.pending_domains}</span>
            <span className="stat-desc">Pending</span>
          </div>
          
          <div className="stat-item">
            <span className="stat-value">{stats.failed_domains}</span>
            <span className="stat-desc">Failed</span>
          </div>
          
          <div className="stat-item">
            <span className="stat-value">{stats.suspended_domains}</span>
            <span className="stat-desc">Suspended</span>
          </div>
          
          <div className="stat-item">
            <span className="stat-value">
              {stats.total_domains > 0 ? 
                ((stats.active_domains / stats.total_domains) * 100).toFixed(1) : 0
              }%
            </span>
            <span className="stat-desc">Success Rate</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DomainStats;